import { useState, useEffect } from 'react';
import { auth } from '../firebaseConnection'
import { onAuthStateChanged } from 'firebase/auth'
import { Navigate } from 'react-router-dom';

export default function Private({children}){
  const [loading, setLoading] = useState(true)
  const [signed, setSigned] = useState(false)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const userData = {
          uid: user.uid,
          email: user.email,
        };

        localStorage.setItem("@webtasksuser", JSON.stringify(userData));
        setSigned(true);
      } else {
        setSigned(false);
      }

      setLoading(false);
    });

    return () => {
      unsubscribe(); // Remove o listener quando o componente desmontar
    };
    
}, []);


  if(loading){
    return(
      <div></div>
    )
  }

  if(!signed){
    return(
      <Navigate to="/" />
    )
  }

  return children;

}
